import { ContentStoreTagsService } from 'src/services/Tags';

export const createTag = async (
    { accessToken, tag }: App.Tag.CreateMutationVariables,
): Promise<Models.ContentStoreApi.V3.Tag> => ContentStoreTagsService.createTag(accessToken, tag);
